import { SvgIcon, SvgIconProps } from '@mui/material';

export const TabbyLogo = (props: SvgIconProps) => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M15.5549 16.2076C15.1321 16.4157 14.6674 16.5237 14.1961 16.5216C13.181 16.5216 12.6053 16.3591 12.5422 15.5391V15.484C12.5422 15.4513 12.5385 15.4223 12.5385 15.3846V12.9955L12.5422 12.7142V11.0298H12.5385V10.3142L12.5422 10.0307V8.40433L10.0247 8.73642C11.7272 8.40723 12.7046 7.06004 12.7046 5.7172V4.88989H9.87607V8.75745L9.71655 8.8024V15.9654C9.81009 17.9775 11.1355 19.1739 13.3115 19.1739C14.0808 19.1739 14.9277 18.9991 15.5759 18.7048L15.5904 18.699V16.1866L15.5541 16.2083V16.2076H15.5549Z"
            fill="#292929"
        />
        <path
            d="M16.0009 7.82495L8.06348 9.04815V11.061L16.0009 9.83776V7.82495Z"
            fill="#292929"
        />
        <path
            d="M16.0009 10.7695L8.06348 11.9927V13.9156L16.0009 12.6917V10.7695Z"
            fill="#292929"
        />
    </SvgIcon>
);